import { TFunction } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import BriaFaqSection from "../../../common/BriaFaqSection/BriaFaqSection";
import LinkConstants from "../../../../constants/LinkConstants";
import { FaqItem } from "../../../common/BriaFaqSection/faq";

// Move MCP FAQ logic inline since it's simple
function getMcpFaqs(t: TFunction): FaqItem[] {
	return [
		{
			question: t("questions.0.question"),
			answer: [{ type: "text", content: t("questions.0.answer") }],
		},
		{
			question: t("questions.1.question"),
			answer: [
				{
					type: "paragraphWithListAndLink",
					intro: t("questions.1.answer.part1"),
					list: t("questions.1.answer.services", { returnObjects: true }),
				},
			],
		},
		{
			question: t("questions.2.question"),
			answer: [{ type: "text", content: t("questions.2.answer") }],
		},
		{
			question: t("questions.3.question"),
			answer: [{ type: "text", content: t("questions.3.answer") }],
		},
		{
			question: t("questions.4.question"),
			answer: [{ type: "text", content: t("questions.4.answer") }],
		},
	];
}

const handleAnswerLinkClick = (id: string) => {
	if (id === "contactUs") {
		window.open(LinkConstants.BRIA_MCP_CONTACT_URL, "_blank");
	}
};

const McpServerFaqSection: React.FC = () => {
	const { t } = useTranslation("translation", { keyPrefix: "mcpServer.faqSection" });
	const faqItems = getMcpFaqs(t);

	return (
		<BriaFaqSection
			title={t("faqTitle")}
			faqItems={faqItems}
			onLinkClick={handleAnswerLinkClick}
		/>
	);
};

export default McpServerFaqSection;
